import {
  Datagrid,
  FunctionField,
  ImageField,
  List,
  SelectInput,
  TextField,
  useRecordContext,
} from 'react-admin';
import { InvitationLink } from '../../components/EntityLink';
import { StatusChip } from '../../components/StatusChip';
import { ModeratePhotoButtons } from './PhotoActions';
import {
  formatDateTime,
  invitationCategoryLabels,
  label,
  photoStatusLabels,
} from '../../i18n/labels';

const filters = [
  <SelectInput
    key="status"
    source="status"
    label="Статус модерации"
    choices={[
      { id: 'pending', name: 'На проверке' },
      { id: 'approved', name: 'Одобрено' },
      { id: 'rejected', name: 'Отклонено' },
      { id: 'all', name: 'Все' },
    ]}
    alwaysOn
  />,
];

function PhotoRowActions(): JSX.Element | null {
  const record = useRecordContext<{ id: string; status: string }>();
  if (!record) return null;
  return <ModeratePhotoButtons photoId={record.id} status={record.status} />;
}

export function PhotosList(): JSX.Element {
  return (
    <List
      filters={filters}
      filterDefaultValues={{ status: 'pending' }}
      perPage={50}
      pagination={false}
    >
      <Datagrid bulkActionButtons={false} rowClick={false}>
        <ImageField source="photoUrl" label="Фото" sx={{ '& img': { maxHeight: 80 } }} />
        <FunctionField
          label="Приглашение"
          render={(record: { invitationId: string; invitation: { category: string } | null }) => (
            <InvitationLink
              id={record.invitationId}
              label={
                record.invitation
                  ? label(invitationCategoryLabels, record.invitation.category)
                  : undefined
              }
            />
          )}
        />
        <FunctionField
          label="Статус"
          render={(record: { status: string }) => (
            <StatusChip status={record.status} dict={photoStatusLabels} />
          )}
        />
        <TextField source="position" label="Поз." />
        <TextField source="rejectionReason" label="Причина" />
        <FunctionField
          label="Загружено"
          render={(record: { createdAt: string }) => formatDateTime(record.createdAt)}
        />
        <PhotoRowActions />
      </Datagrid>
    </List>
  );
}
